
import './App.css';
import About from './Components/About/About';
import Contact from './Components/Contact/Contact';
import Footer from './Components/Footer/Footer';
import Header from './Components/Header/Header';
import Home from './Components/Home/Home';
import Projects from './Components/Projects/Projects';

function App() {
  return (
    <>
    <Header></Header>
    <Home></Home>
    <About></About>
    <Projects></Projects>
    <Contact></Contact>
    <Footer></Footer>
    </>
    
  );
}

export default App;
